import { render, staticRenderFns } from "./editStorechannel.vue?vue&type=template&id=76555e56&scoped=true"
import script from "./editStorechannel.vue?vue&type=script&lang=js"
export * from "./editStorechannel.vue?vue&type=script&lang=js"
import style0 from "./editStorechannel.vue?vue&type=style&index=0&id=76555e56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76555e56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76555e56')) {
      api.createRecord('76555e56', component.options)
    } else {
      api.reload('76555e56', component.options)
    }
    module.hot.accept("./editStorechannel.vue?vue&type=template&id=76555e56&scoped=true", function () {
      api.rerender('76555e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsChannel/editStorechannel.vue"
export default component.exports